<template>
    <div>
        <div v-if="!initialised" class="d-flex justify-content-center mt-4">
            <strong>Loading...</strong>
            <div class="ml-5 spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="initialised">
            <div class="card mt-2">
                <div class="card-header">We can include Airport Transfers from Dublin, Belfast, Knock and Donegal Airports</div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                        <font-awesome-icon icon="plane-departure" />
                        <span class="ml-2">
                            If you will be flying in to Ireland, and know the airports that you will be arriving and departing Ireland from then please let us know.
                        </span>
                    </li>
                    <li class="list-group-item">
                        <font-awesome-icon icon="plane" />
                        <span class="ml-2">
                            If you will be flying into Ireland but don't know which Airport yet, don't worry, we can get this information from you closer to departure.
                        </span>
                    </li>
                    <li class="list-group-item">
                        <font-awesome-icon icon="plane-slash" />
                        <span class="ml-2">
                            If you prefer to make your own way to Donegal, then that is no problem, we will not include transfers in your price.
                        </span>
                    </li>
                </ul>
            </div>
            
            <div class="card mt-2">
                <div class="card-header">Would you like us to include Airport transfers?</div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" id="yes" value="yes" v-model="requireTransfers">
                            <label class="custom-control-label" for="yes">Yes, we know our arrival and departure airports</label>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" id="no" value="no" v-model="requireTransfers">
                            <label class="custom-control-label" for="no">Yes, but we don't know our arrival and departure airports</label>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" id="none" value="none" v-model="requireTransfers">
                            <label class="custom-control-label" for="none">No thanks, we'll arrange our own transport to and from Donegal</label>
                        </div>
                    </li>
                    <li v-if="$v.requireTransfers.$error && $v.requireTransfers.required" class="list-group-item">
                        <div class="validation-message">Please select an option above.</div>
                    </li>
                    <li v-if="requireTransfers == 'yes'" class="list-group-item">
                        <div  class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="arrAirport">Arrival Airport</label>
                                    <select v-model="inboundAirport" 
                                        id="arrAirport" class="form-control" :class="{ invalid: $v.inboundAirport.$error }"
                                        @blur="$v.inboundAirport.$touch()">
                                        <option v-for="airport in airports" 
                                                :key="airport.airportId"
                                                :value="airport"
                                                class="form-control-item">{{ airport.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label for="toDate">Departure Airport</label>
                                    <select v-model="outboundAirport" 
                                        id="depAirport" class="form-control" :class="{ invalid: $v.outboundAirport.$error }"
                                        @blur="$v.outboundAirport.$touch()">
                                        <option v-for="airport in airports" 
                                                :key="airport.airportId"
                                                :value="airport"
                                                class="form-control-item">{{ airport.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="$v.inboundAirport.$error" class="col validation-message">Please select your arrival airport</div>
                            <div v-if="$v.outboundAirport.$error" class="col validation-message"
                                    :class="{ 'offset-6': !$v.inboundAirport.$error }">Please select your departure airport</div>
                        </div>
                    </li>
                </ul>
            </div>
                
            <div class="row my-4 justify-content-end">
                <button class="btn btn-info mx-1" @click="prevStep">Previous</button>
                <button class="btn btn-success mx-1" @click="nextStep">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
    computed: {
        ...mapState({
            airports: state => state.static.airports
        }), 
        initialised() { 
            return this.$store.state.static.airports.length > 0;
        },
        requireTransfers: {
            get() { 
                return this.$store.state.transfers.requireTransfers;
            },
            set(value) {
                return this.setRequireTransfers(value);
            }
        },
        inboundAirport: {
            get() { 
                return this.$store.state.transfers.inboundAirport;
            },
            set(value) {
                return this.setInboundAirport(value);
            }
        },
        outboundAirport: { 
            get() { 
                return this.$store.state.transfers.outboundAirport;
            },
            set(value) {
                return this.setOutboundAirport(value);
            }
        }
    },
    methods: {
        ...mapActions([ 'setRequireTransfers', 'setInboundAirport', 'setOutboundAirport', 'prevStep' ]),
        nextStep() {
            // if we have validation errors then 
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                this.$store.dispatch('nextStep');
            }
        }
    },
    validations() { 
        return { 
            requireTransfers: { required },
            inboundAirport: {
                required: requiredIf((model) => {
                    return this.requireTransfers == 'yes'
                })
            },
            outboundAirport: {
                required: requiredIf((model) => {
                    return this.requireTransfers == 'yes'
                })
            }
        }
    },
    created() {
        this.$store.dispatch('initAirports');
    }
}
</script>